"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveLensPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const web_i18n_1 = require("@snapchat/web-i18n");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const useBootstrapLiveLens_1 = require("../../hooks/useBootstrapLiveLens");
const grafana_1 = require("../../lib/grafana");
const state_utils_1 = require("../../lib/state-utils");
const liveLensState_1 = require("../../liveLensState");
const LiveLensCanvas_1 = require("../LiveLensCanvas");
const LiveLensFailed_1 = require("../LiveLensFailed");
const LoadingLiveLens_1 = require("../LoadingLiveLens");
const LiveLensPreview_module_css_1 = __importDefault(require("./LiveLensPreview.module.css"));
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const messageLoader_1 = require("../../../i18n/messageLoader");
const METRICS_INTERVAL = 5000;
/**
 *
 * Previews the Live Lens to the user
 *
 * liveLensState: various state of the live lens
 * setLiveLensState: setter for live lens state
 * lensId: ID of the lens to be downloaded and previewed
 * lensGroupId: GroupdID which the lens belongs to
 * lensName: name of the lens
 *
 */
function LiveLensPreview({ liveLensState, setLiveLensState, lensId, lensGroupId, locale: defaultLocale, pageType, lensName, isMobile, }) {
    const { locale, messages } = (0, web_i18n_1.useLocale)({
        defaultLocale,
        loadMessages: messageLoader_1.loadMessages,
    });
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)();
    const liveLensCanvasRef = (0, useBootstrapLiveLens_1.useBootstrapLiveLens)({
        liveLensState,
        setLiveLensState,
        lensId,
        lensGroupId,
        pageType,
    });
    (0, react_1.useEffect)(() => {
        if (liveLensState === liveLensState_1.LiveLensState.APPLIED) {
            const liveLensStartedTime = new Date().getTime();
            const interval = setInterval(() => {
                void (0, grafana_1.addTimer)({
                    metricsPrefix: grafana_1.grafanaBasePrefix,
                    pageName: web_blizzard_reporting_1.PageType[pageType],
                    millis: new Date().getTime() - liveLensStartedTime,
                    name: `TimeSpentOnLens.${(0, grafana_1.getDeviceName)()}`,
                });
            }, METRICS_INTERVAL);
            return () => clearInterval(interval);
        }
    }, [liveLensState, pageType]);
    const logSendToAppClick = (0, react_1.useCallback)(async () => {
        (0, web_blizzard_reporting_1.reportWebAction)({
            pageType,
            actionName: web_blizzard_reporting_1.WebActionName.OpenWebChatCta,
            actionSource: web_blizzard_reporting_1.WebActionSource.LiveLens,
            webClientId: webClientId ?? "",
        });
        (0, grafana_1.incrementCounter)(`SendToApp.byDeviceName.${(0, grafana_1.getDeviceName)()}.Click`);
        await graphene_1.default.flush();
    }, [pageType, webClientId]);
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { locale: locale, defaultLocale: web_i18n_1.DEFAULT_LOCALE, messages: messages, children: (0, jsx_runtime_1.jsxs)("div", { className: LiveLensPreview_module_css_1.default.previewCard, "data-testid": "liveLensPreview", children: [(0, state_utils_1.isLensInactive)(liveLensState) && null, (0, state_utils_1.isLensLoading)(liveLensState) && ((0, jsx_runtime_1.jsx)(LoadingLiveLens_1.LoadingLiveLens, { liveLensState: liveLensState, lensName: lensName })), (0, state_utils_1.isErrorState)(liveLensState) && ((0, jsx_runtime_1.jsx)(LiveLensFailed_1.LiveLensFailed, { liveLensState: liveLensState, lensName: lensName })), (0, state_utils_1.isLensActive)(liveLensState) && !isMobile && ((0, jsx_runtime_1.jsx)("div", { className: LiveLensPreview_module_css_1.default.sendToAppBtn, "data-testid": "send_to_app_btn", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.SuppressedDefaultActionLink, { link: "https://web.snapchat.com/?ref=web_live_lens_open_snapchat", logMetric: logSendToAppClick, openInNewTab: true, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.WHITE, icon: (0, jsx_runtime_1.jsx)(web_core_ui_1.DesktopIcon, { size: "MEDIUM" }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "shua65", description: "CTA on active live lens that redirects to Web chat", defaultMessage: "Open Snapchat" }) }) }) })), (0, jsx_runtime_1.jsx)(LiveLensCanvas_1.LiveLensCanvas, { ref: liveLensCanvasRef })] }) }));
}
exports.LiveLensPreview = LiveLensPreview;
//# sourceMappingURL=LiveLensPreview.js.map